import { render, staticRenderFns } from "./DocumentTemplateSelection.vue?vue&type=template&id=269bdb7b"
import script from "./DocumentTemplateSelection.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports